exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._201ykWwx3JLD0jIwXOUB0K{width:100%;height:100%;text-align:center}._1pdeOJNbdTWsAxe_yzJnil{display:flex;align-items:center;justify-content:space-between;padding:0 10px}.vVfwAvHhaFErka1X0Qr8n{line-height:50px;text-align:left;padding:10px;font-size:20px}.vVfwAvHhaFErka1X0Qr8n a,.vVfwAvHhaFErka1X0Qr8n a:hover{color:#000}.vVfwAvHhaFErka1X0Qr8n img{width:50px;vertical-align:middle;margin-right:10px}._1j76DKH-1on8u_8S6SjDzg{display:inline-flex;align-items:center;gap:8px;font-size:14px;color:#57606a;padding:0 10px}._1j76DKH-1on8u_8S6SjDzg a{color:#57606a;text-decoration:none;padding:2px 6px;border-radius:4px}._1j76DKH-1on8u_8S6SjDzg a:hover{color:#000;background:#f6f8fa}._22DwBYZLjVIc9SPC60tuoA{color:#000;font-weight:700;padding:2px 6px}.Rgr6pRrFXZ8dXolb5vRyY{color:#d0d7de}@media (max-height:900px){.vVfwAvHhaFErka1X0Qr8n{line-height:30px;text-align:left;padding:10px;font-size:18px}.vVfwAvHhaFErka1X0Qr8n img{width:30px;vertical-align:middle;margin-right:10px}}", ""]);

// exports
exports.locals = {
	"container": "_201ykWwx3JLD0jIwXOUB0K",
	"header": "_1pdeOJNbdTWsAxe_yzJnil",
	"logo": "vVfwAvHhaFErka1X0Qr8n",
	"lang": "_1j76DKH-1on8u_8S6SjDzg",
	"langActive": "_22DwBYZLjVIc9SPC60tuoA",
	"langSep": "Rgr6pRrFXZ8dXolb5vRyY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"module":true,"minimize":true}!./src/routes/app/comp.App.module.css
// module id = 240
// module chunks = 4